module.exports = __webpack_public_path__ + "img/yayaphone.6f7f0e72.png";